import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-terms-and-condition-modal',
  templateUrl: './terms-and-condition-modal.component.html',
  styleUrls: ['./terms-and-condition-modal.component.scss'],
})
export class TermsAndConditionModalComponent implements OnInit, OnDestroy {
  @Input('data') data: any;
  addonCMSUrl: string;
  sku: any;
  lang: string;
  constructor(
    private modalController: ModalController,
    private UTS: UtilitiesService,
    private SS: SubjectService,
    private cdr: ChangeDetectorRef
  ) {}
  ngOnDestroy(): void {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.sku = this.data;
    this.lang = this.UTS.getLocaleLanguage().toLocaleLowerCase();
    if (this.lang == 'ar') {
      this.addonCMSUrl = this.sku?.tAndcAcceptanceAr;
    } else {
      this.addonCMSUrl = this.sku?.tAndcAcceptanceEn;
    }
  }

  dismiss() {
    this.modalController.dismiss();
  }
  continue(){
   this.SS.acceptTermsAndConditions.next(true)
    this.modalController.dismiss();
    this.cdr.detectChanges();
  }
  
}
